"use client";

import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@retailos/core";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, label, error, helperText, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");

    return (
      <div className="space-y-2">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-white/70">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            "w-full rounded-xl border bg-surface px-4 py-3 text-base text-white placeholder:text-text-dim",
            "transition-all duration-200",
            "focus:outline-none focus:ring-2 focus:ring-accent/30 focus:border-surface-border-2",
            error ? "border-danger/50" : "border-surface-border",
            className,
          )}
          {...props}
        />
        {error && <p className="text-xs text-danger">{error}</p>}
        {helperText && !error && <p className="text-xs text-text-dim">{helperText}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";
